/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tfield_Name_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Tournament name" |
*
* @param {Tfield_Name_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tfield_name_placeholder = /** @type {((inputs?: Tfield_Name_PlaceholderInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tfield_Name_PlaceholderInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Nom du tournoi")
	if (locale === "es") return /** @type {LocalizedString} */ ("Nombre del torneo")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Nome do torneio")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nome del torneo")
	return /** @type {LocalizedString} */ ("Tournament name")
});